export default {
  'app.network.offline':
    'شما اکنون آفلاین هستید. برخی از قابلیت‌ها ممکن است در دسترس نباشند.',
  'app.error.chunk.title': 'بارگذاری صفحه ناموفق بود',
  'app.error.chunk.description.offline':
    'اتصال شبکه شما قطع شده است. اتصال خود را بررسی کنید و صفحه را بارگذاری مجدد کنید.',
  'app.error.chunk.description.online':
    'بارگذاری منابع صفحه ناموفق بود. لطفاً صفحه را بارگذاری مجدد کنید.',
  'app.error.render.title': 'خطایی رخ داد',
  'app.error.render.description':
    'متأسفانه، در این صفحه خطایی رخ داد. لطفاً صفحه را بارگذاری مجدد کنید یا به صفحه اصلی بازگردید.',
  'app.error.retry': 'تلاش مجدد',
  'app.error.reload': 'بارگذاری مجدد صفحه',
  'app.error.home': 'بازگشت به صفحه اصلی',
  'app.request.offline':
    'شبکه در دسترس نیست. لطفاً اتصال خود را بررسی و دوباره تلاش کنید.',
};
